import { SP } from '../../lib/shareTokens'
import StationMark from './StationMark'
import StoreBadge from './StoreBadge'

interface Props {
  variant: 'event' | 'group'
  onOpen: () => void
  /** Localised button label; falls back to the English default for the variant. */
  label?: string
  /**
   * ON-407: web RSVP. When set, the primary button RSVPs on the web and
   * `label` / `onOpen` become a secondary "open in the app" button.
   */
  rsvp?: { label: string; onClick: () => void }
}

export default function StickyCTA({ variant, onOpen, label: labelProp, rsvp }: Props) {
  const label = labelProp ?? (variant === 'event' ? 'Join this run in the app' : 'Join this group in the app')
  const primaryLabel = rsvp ? rsvp.label : label
  return (
    <div
      data-testid="sticky-cta"
      style={{
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 30,
        padding: '14px 20px 22px',
        background: 'linear-gradient(180deg, rgba(12,12,12,0) 0%, rgba(12,12,12,0.96) 40%)',
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
      }}
    >
      <button
        onClick={rsvp ? rsvp.onClick : onOpen}
        data-testid={rsvp ? 'rsvp-cta' : undefined}
        style={{
          display: 'flex',
          gap: 10,
          padding: '14px 18px',
          borderRadius: 999,
          background: SP.lime,
          color: SP.charcoal,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: SP.ui,
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: `0 10px 30px ${SP.lime}55`,
          marginBottom: 10,
          width: '100%',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        <StationMark size={14} color={SP.charcoal} />
        {primaryLabel}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M5 12h14m-6-6l6 6-6 6" stroke={SP.charcoal} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {rsvp ? (
        <button
          onClick={onOpen}
          data-testid="open-in-app-cta"
          style={{
            display: 'block',
            width: '100%',
            padding: '12px 18px',
            borderRadius: 999,
            background: 'transparent',
            color: SP.text,
            border: `1px solid ${SP.borderBright}`,
            fontSize: 13,
            fontWeight: 600,
            fontFamily: SP.ui,
            cursor: 'pointer',
          }}
        >
          {label}
        </button>
      ) : (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <StoreBadge platform="ios" />
          <StoreBadge platform="android" />
        </div>
      )}
    </div>
  )
}
